import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n          display: inline-flex;\n          flex-wrap: nowrap;\n          gap: 0.5rem;\n          align-items: center;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n          display: inline-block;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n          padding: 0.125rem 0.25rem;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n          padding: 0.25rem 1rem;\n          border-radius: 100px;\n          font-size: 1rem;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n      ",
        " {\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { darken } from "polished";
import { getLinearGradient } from "../../Theme";
var textColorStylesBadge = {
    default: "dark",
    dark: "light",
    light: "dark",
    orange: "light",
    green: "light",
    "orange-gradient": "light",
    "green-gradient": "light"
};
var mapColor = function(theme) {
    var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    return ({
        default: darken(0.02, theme.color.natural10),
        dark: darken(0.599, theme.color.natural10),
        light: theme.color.natural0,
        orange: theme.color.natural70,
        green: theme.color.primary,
        "orange-gradient": theme.color.natural70,
        "green-gradient": theme.color.primary
    })[color];
};
var Wrapper = /*#__PURE__*/ styled("span", {
    target: "e1u2lcnv0"
})(function(param) {
    var hasIcon = param.hasIcon;
    return hasIcon ? css(_templateObject()) : css(_templateObject1());
}, ";", function(param) {
    var badgeSize = param.badgeSize;
    return badgeSize === "small" ? css(_templateObject2()) : css(_templateObject3());
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:600;text-align:center;text-transform:uppercase;white-space:nowrap;line-height:1.5;fill:currentcolor;color:", function(param) {
    var theme = param.theme, badgeType = param.badgeType;
    return mapColor(theme, textColorStylesBadge[badgeType]);
}, ";background-color:", function(param) {
    var theme = param.theme, badgeType = param.badgeType;
    return mapColor(theme, badgeType);
}, ";background-image:", function(param) {
    var theme = param.theme, badgeType = param.badgeType;
    switch(badgeType){
        case "orange-gradient":
            return getLinearGradient(theme.gradient.orange, "to left");
        case "green-gradient":
            return getLinearGradient(theme.gradient.green, "to left");
        default:
            return "";
    }
}, ";", function(param) {
    var theme = param.theme, badgeSize = param.badgeSize;
    return badgeSize !== "small" && css(_templateObject4(), theme.mq("lg"));
});
export { Wrapper };
